import CmsButtons from '../../services/cms/CmsButtons';

const generateStyle = (alignment, orientation) => {
    const style = {};

    switch (orientation) {
        case CmsButtons.orientation.row:
            generateRowStyle(style, alignment);
            return style;
        case CmsButtons.orientation.column:
            generateColumnStyle(style, alignment);
            return style;
        default:
            return style;
    }
};

const generateRowStyle = (style, alignment) => {
    switch (alignment) {
        case CmsButtons.alignment.leftOrTop:
            style.justifyContent = 'flex-start';
            style.alignItems = 'center';
            break;
        case CmsButtons.alignment.center:
            style.justifyContent = 'center';
            style.alignItems = 'center';
            break;
        case CmsButtons.alignment.rightOrBottom:
            style.justifyContent = 'flex-end';
            style.alignItems = 'center';
            break;
        case CmsButtons.alignment.stretch:
            style.justifyContent = 'space-between';
            style.alignItems = 'center';
            break;
        default:
            break;
    }
};

const generateColumnStyle = (style, alignment) => {
    switch (alignment) {
        case CmsButtons.alignment.leftOrTop:
            style.justifyContent = 'flex-start';
            style.alignItems = 'flex-start';
            break;
        case CmsButtons.alignment.center:
            style.justifyContent = 'flex-start';
            style.alignItems = 'center';
            break;
        case CmsButtons.alignment.rightOrBottom:
            style.justifyContent = 'flex-start';
            style.alignItems = 'flex-end';
            break;
        case CmsButtons.alignment.stretch:
            style.justifyContent = 'flex-start';
            style.alignItems = 'center';
            break;
        default:
            break;
    }
};

export default generateStyle;
